export default {
  data: { data: [], current_page: 1, last_page: 1, total: 0 },
  options: { vehicle_categories: [], vehicle_locations: [], transmissions: [], fuels: [], service_types: [] },
};
